<!--
    Text Modal Component
    <text-modal-component></text-modal-component>
-->

<template>
    <div class="text-modal-component">
        <div class="text-modal">
            <header class="modal-header">
                <slot name="header">
<!--                    <h3>default header</h3>-->
                </slot>
                <button type="button" class="btn-close" @click="close">
                    <i class="icon-cross"></i>
                </button>
            </header>
            <section class="modal-body">
                <slot name="body">
                    <p>default body</p>
                </slot>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'modalTitle',
            'modalText'
        ],
        methods: {
            close() {
                this.$emit('close');
            },
        }
    }
</script>
